import React from 'react';
import { Link } from "react-router";
import { t } from '../../../helpers/translator';

export default function nextRacing () {
    if (this.props.data) {
        const { sportId } = this.props;
        const [firstGame = {}] = this.props.data;
        const { regionId = '', competitionId = '', id = '', start_ts: startTs = 0, regionName, regionAlias = '' } = firstGame;
        const diffSeconds = startTs - Math.floor(Date.now() / 1000);
        const hour = Math.floor(diffSeconds / 3600), minute = Math.floor((diffSeconds - (hour * 3600)) / 60);
        let newUrl = sportId === 31 ? "/horseRacing/" : '/greyhounds/';
        let checkAvailableRacing = hour >= 0;
        const isPageActive = this.props.location.pathname.includes(newUrl)

        if (this.props.size === 'small') {
            return (
                <Link to={`${newUrl}${this.props.sportId}/${regionId}/${competitionId}/${id}`} className={`next-racing ${sportId === 31 ? 'horse' : 'dog'} ${isPageActive ? 'page-active' : ''}`} activeClassName="active" >
                    <p className="name-and-country"><span className={`flag-view-m icon-${regionAlias.toLowerCase()}`}/> { regionName }</p>
                    <p className="count-down-h">
                        {
                            checkAvailableRacing &&
                                <span><b>{ hour === 0 ? "0" : hour }</b> <i>{t("hours")}</i></span>
                        }
                        <span><b>{ minute }</b><i>{t("minutes")}</i></span>
                    </p>
                </Link>
            );
        }
        return (
            <Link to={`${newUrl}${this.props.sportId}/${regionId}/${competitionId}/${id}`} className={`next-racing ${sportId === 31 ? 'horse' : 'dog'} `} activeClassName="active" >
                <div className="bg-color"></div>
                <i>
                    {t(`Next ${sportId === 31 ? 'horse racing' : 'greyhounds'}`)}
                </i>
                {
                    checkAvailableRacing
                        ? <>
                            <p className="name-big-country"><span className={`flag-view-m icon-${regionAlias.toLowerCase()}`}/> { regionName }</p>
                            <p className="count-down-h">
                                <span>{ hour === 0 ? "0" : hour } <i>{t("hours")}</i></span>
                                <span>{ minute }<i>{t("minutes")}</i></span>
                            </p>
                        </> : <span>{t("There are no upcoming games")}</span>
                }

            </Link>
        );
    }
    return null;
}